import React from "react";

interface ConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    content: string;
    confirmButtonText?: string;
    confirmButtonVariant?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
                                                       isOpen,
                                                       onClose,
                                                       onConfirm,
                                                       title,
                                                       content,
                                                       confirmButtonText = 'Confirm',
                                                       confirmButtonVariant = 'bg-blue-500 hover:bg-blue-600'
                                                   }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md">
                <h2 className="text-lg font-semibold mb-4">{title}</h2>
                <p className="mb-4">{content}</p>
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className="bg-gray-300 text-black py-2 px-4 rounded hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`text-white py-2 px-4 rounded ${confirmButtonVariant}`}
                    >
                        {confirmButtonText}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal